export const homeObjOne = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Our Story",
  headline: "Indomitables",
  description:
    "Ignited by the brewing will to be change agents, due to the global status quo and living beyond social constructs.",
  // buttonLabel: "Get Started",
  imgStart: false,
  img: require("../../images/story.svg").default,
  alt: "Car",
  dark: true,
  primary: true,
  darkText: false,
};

export const homeObjTwo = {
  id: "vision",
  lightBg: true,
  lightText: true,
  lightTextDesc: false,
  topLine: "Our Vision",
  headline: "Redifine Humanity",
  description:
    "Unconventionally reshaping the mindset of the society by highlighting the power of the unknown.",
  // buttonLabel: "Get Started",
  imgStart: false,
  img: require("../../images/people.svg").default,
  alt: "Car",
  dark: true,
  primary: true,
  darkText: false,
};

export const homeObjThree = {
  id: "mission",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Mission Statement",
  headline: "Consistency",
  description:
    "Consistently making conscious efforts in all ramifications and influencing general spheres positively.",
  // buttonLabel: "Get Started",
  imgStart: true,
  img: require("../../images/adventure.svg").default,
  alt: "Car",
  dark: true,
  primary: true,
  darkText: false,
};

export const homeObjFour = {
  id: "channels",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Channels",
  headline: "Sustainable Systems",
  description:
    "Individual and communal tales of cultural authenticity, innovation, stability and value",
  // buttonLabel: "Get Started",
  imgStart: true,
  // img: require("../../images/svggggg.svg").default,
  alt: "Car",
  dark: true,
  primary: true,
  darkText: false,
};

export const homeObjFive = {
  id: "membership",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Join Us",
  headline: "Become an Olympian",
  description:
    "Click any of the buttons to join this community of distinguished individuals",
  buttonLabel: "Join Now",
  imgStart: true,
  img: require("../../images/svg.svg").default,
  alt: "Car",
  dark: true,
  primary: true,
  darkText: false,
};
